import { useEffect } from 'react';

const QUESTIONNAIRE_TOP_GAP = 16;

function getAdjustedTop(top: number) {
  const header = document.querySelector(
    '[data-questionnaire-header="true"]',
  ) as HTMLElement | null;
  const headerHeight = header?.getBoundingClientRect().height ?? 0;

  if (top <= 0 || headerHeight <= 0) {
    return top;
  }

  return Math.max(0, top - headerHeight - QUESTIONNAIRE_TOP_GAP);
}

export default function useQuestionnaireScrollCompensation(enabled: boolean) {
  useEffect(() => {
    let cleanup = () => {};

    if (enabled && typeof window !== 'undefined') {
      const originalScrollTo = window.scrollTo.bind(window);

      window.scrollTo = ((options?: ScrollToOptions | number, y?: number) => {
        if (typeof options === 'object' && options !== null && typeof options.top === 'number') {
          originalScrollTo({
            ...options,
            top: getAdjustedTop(options.top),
          });
          return;
        }

        if (typeof options === 'number') {
          originalScrollTo(options, getAdjustedTop(y ?? 0));
          return;
        }

        originalScrollTo();
      }) as typeof window.scrollTo;

      cleanup = () => {
        window.scrollTo = originalScrollTo;
      };
    }

    return cleanup;
  }, [enabled]);
}
